import { Box } from '@chakra-ui/layout'
import React, { Component } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'

class Confirmation extends Component {
    cancel = () => {
        let { onCancel } = this.props
        if (onCancel) {
            onCancel()
        }
    }

    confirm = () => {
        let { onConfirm } = this.props
        if (onConfirm) {
            onConfirm()
        }
    }

    render() {
        let { showModal, message } = this.props

        return (
            <Modal onClose={this.closeModal} open={showModal}>
                <Modal.Header>Conferma azione</Modal.Header>
                <Modal.Content image scrolling style={{ padding: 0 }}>
                    <Box p={6} placeholder style={{ width: '100%' }}>
                        <Box textStyle="header" style={{ fontSize: '30pt' }} icon>
                            <Icon name="warning" />
                            {message ? message : 'Sei sicuro?'}
                        </Box>
                    </Box>
                </Modal.Content>
                <Modal.Actions>
                    <Button secondary onClick={this.cancel}>
                        Annulla <Icon name="close" />
                    </Button>
                    <Button primary onClick={this.confirm}>
                        Conferma <Icon name="check" />
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default Confirmation
